import React from 'react';

import { FormikPhoneInput } from 'components';
import { FormFieldProps, GetFieldValidatorFn } from 'types';

import { getTCommon, useTFeature } from '../fields.utils';
import { getBaseFieldValidator } from '../form.validators';

export const Field: React.FC<FormFieldProps> = ({
  name,
  required = false,
  disabled = false,
}) => {
  const { t } = useTFeature();

  return (
    <FormikPhoneInput
      name={name}
      label={t('fields.phone.label')}
      fullWidth
      required={required}
      disabled={disabled}
    />
  );
};

export const getValidator: GetFieldValidatorFn = ({ required }) => {
  const tCommon = getTCommon();

  return getBaseFieldValidator({ required }).matches(
    // check 11 digits for russian phones and 10..15 for others
    /^\+(?:7\d{10}|[1-68-9]\d{9,14})$/,
    tCommon('errors.invalid'),
  );
};
